import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CollectionsService {
  // Users
  public usersCol() {
    return `${environment.col.USERS}`;
  }

  // User Settings
  public userSettingsCol() {
    return `${environment.col.SETTINGS}`;
  }

  // User Exports
  public userExportsCol(userId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.EXPORTS}`;
  }

  // Folders
  public foldersCol(userId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.FOLDERS}`;
  }

  // Projects
  public projectsCol(userId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.PROJECTS}`;
  }

  // Attachments library
  public attachmentsCol(userId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.ATTACHMENTS}`;
  }

  // Report header and footer combinations
  public reportHeadersFootersCol(userId: string) {
    return `${environment.col.USERS}/${userId}/report_headers_footers`;
  }

  // Clients
  public clientsCol(userId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.CLIENTS}`;
  }

  // Issues
  public issuesCol(userId: string, projectId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.PROJECTS}/${projectId}/${environment.col.ISSUES}`;
  }

  // Assignees
  public assigneesCol(userId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.ASSIGNEES}`;
  }

  // Supplementary
  public supplementaryCol(userId: string, projectId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.PROJECTS}/${projectId}/${environment.col.SUPPLEMENTARY}`;
  }

  // Images
  public imagesCol(userId: string, projectId: string, issueId: string) {
    return `${environment.col.USERS}/${userId}/${environment.col.PROJECTS}/${projectId}/${environment.col.ISSUES}/${issueId}/${environment.col.IMAGES}`;
  }

  // Billing
  public billingCol() {
    return `${environment.col.BILLING}`;
  }

  // Stats
  public statsCol() {
    return `${environment.col.STATS}`;
  }

  // Settings
  public settingsCol() {
    return `${environment.col.SETTINGS}`;
  }

  // User Status
  public userStatusCol() {
    return `${environment.col.USER_STATUS}`;
  }

  // Operations
  public operationsCol(userId: string) {
    return `${environment.col.USERS}/${userId}/operations`;
  }

  // User Tags
  public userTagsCol(userId: string) {
    return `${environment.col.USERS}/${userId}/tags`;
  }
}
